import React from "react";
import { hrefRouter as bannoRouter, isSMSCapable, getOS } from "../utils/utils";
import { MOBILE_PROVIDERS } from "../constants/mobileProviders";
import { ROUTE_CONSTANTS } from "../constants/routeConstants";

export const canSendSMS = isSMSCapable();

export const clickSendSms = (messageBody, phoneNum) => {
  // On Android, skip opening the SMS app entirely to avoid screen flickering
  // and iframe issues. The caller should display the message for copy/paste instead.
  if (getOS() === "android") {
    return;
  }

  const { SEND_SMS_PAGE } = ROUTE_CONSTANTS;
  const mobileProvider = localStorage.getItem("mobileProvider");
  let href = `sms:${phoneNum}?body=${encodeURIComponent(messageBody)}`;
  if (mobileProvider === MOBILE_PROVIDERS.BANNO) {
    bannoRouter(href, true);
  } else if (mobileProvider === MOBILE_PROVIDERS.MEA) {
    window.location.href = href;
  } else if (
    mobileProvider === MOBILE_PROVIDERS.ALKAMI &&
    !window.location.pathname.includes(SEND_SMS_PAGE)
  ) {
    href = `${window.location.origin}/app/send-sms?phoneNumber=${phoneNum}&smsMessage=${encodeURIComponent(messageBody)}`;
    const a = document.createElement("a");
    a.href = href;
    a.target = "browser";
    a.click();
  } else {
    href = `sms:${phoneNum}?body=${encodeURIComponent(messageBody)}`;
    const a = document.createElement("a");
    a.href = href;
    a.click();
  }
};

const SendSms = ({ identifier, disabled, message }) => {
  return (
    <>
      {canSendSMS && getOS() !== "android" && (
        <button
          href="#"
          disabled={disabled}
          onClick={() => {
            clickSendSms(message, identifier);
          }}
          style={{
            fontSize: "12px",
            height: "32px",
            padding: "0",
            borderRadius: "8px",
            minWidth: "200px",
          }}
        >
          Send instructions via text
        </button>
      )}
    </>
  );
};

export default SendSms;
